import React from 'react';

const signals = [
    'EEG',
    'Heart rate',
    'HRV',
    'Movement',
];

const How = () => {
    return (
        <section
            id="technology"
            className="relative overflow-hidden bg-[#080a0f] text-white py-20 sm:py-24"
        >
            {/* Background atmosphere */}
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute left-1/2 top-1/2 h-[500px] w-[850px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#3157ff]/[0.035] blur-[160px]" />
            </div>

            <div className="relative z-10 mx-auto max-w-[1400px] px-8">

                {/* Introduction */}
                <div className="max-w-[900px]">
                    <div className="mb-6 flex items-center gap-3 text-[11px] tracking-[0.28em] text-neutral-500">
                        <span className="h-px w-8 bg-neutral-600" />
                        THE FROCORT APPROACH
                    </div>

                    <h2 className="text-[40px] font-semibold leading-[1.03] tracking-[-0.04em] sm:text-[52px] lg:text-[60px]">
    <span className="text-neutral-500">
        From signals
    </span>
                        <br />
                        to understanding.
                    </h2>

                    <p className="mt-6 max-w-[700px] text-[16px] leading-[1.7] text-neutral-400 sm:text-[17px]">
                        FroCort combines signals from the brain and body with AI
                        to build toward a better understanding of how a person
                        is doing in the moment.
                    </p>
                </div>

                {/* Main pipeline */}
                <div className="mt-14 rounded-[26px] border border-white/10 bg-white/[0.02] p-6 sm:p-8">

                    <div className="grid items-center gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr]">

                        {/* Input */}
                        <div className="rounded-2xl border border-white/10 bg-[#0d1018] p-6">
                            <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-600">
                                Input
                            </div>

                            <h3 className="mt-4 text-[22px] font-medium">
                                Brain + Body
                            </h3>

                            <p className="mt-2 text-[13px] leading-6 text-neutral-500">
                                Signals captured through compatible wearable
                                sensors.
                            </p>

                            <div className="mt-5 flex flex-wrap gap-2">
                                {signals.map((signal) => (
                                    <span
                                        key={signal}
                                        className="rounded-full border border-white/10 px-3 py-1.5 text-[11px] text-neutral-500"
                                    >
                                        {signal}
                                    </span>
                                ))}
                            </div>
                        </div>

                        {/* Desktop arrow */}
                        <div className="hidden text-xl text-neutral-700 lg:block">
                            →
                        </div>

                        {/* Intelligence */}
                        <div className="rounded-2xl border border-[#8ea5ff]/20 bg-[#10162a] p-6">
                            <div className="text-[10px] uppercase tracking-[0.22em] text-[#8ea5ff]">
                                Intelligence
                            </div>

                            <h3 className="mt-4 text-[22px] font-medium">
                                FroCort AI
                            </h3>

                            <p className="mt-2 text-[13px] leading-6 text-neutral-500">
                                Machine learning finds patterns in the signals
                                that can reveal changes in mental state.
                            </p>
                        </div>

                        {/* Desktop arrow */}
                        <div className="hidden text-xl text-neutral-700 lg:block">
                            →
                        </div>

                        {/* Output */}
                        <div className="rounded-2xl border border-white/10 bg-[#0d1018] p-6">
                            <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-600">
                                Output
                            </div>

                            <h3 className="mt-4 text-[22px] font-medium">
                                Understanding
                            </h3>

                            <p className="mt-2 text-[13px] leading-6 text-neutral-500">
                                A clearer picture of how the person is doing
                                in the moment.
                            </p>
                        </div>
                    </div>

                    {/* Mobile flow */}
                    <div className="mt-4 flex justify-center text-neutral-700 lg:hidden">
                        ↓
                    </div>
                </div>

                {/* Simple explanation */}
                <div className="mt-12 grid gap-8 border-t border-white/10 pt-8 sm:grid-cols-[1fr_auto] sm:items-end">

                    <div>
                        <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-600">
                            What happens next
                        </div>

                        <p className="mt-4 max-w-[760px] text-[18px] font-medium leading-[1.5] tracking-[-0.015em] text-neutral-300 sm:text-[21px]">
    <span className="text-neutral-500">
        Signals are captured.
    </span>
                            {' '}Patterns are learned.
                            {' '}Experiences can respond.
                        </p>
                    </div>

                    <p className="max-w-[320px] text-[12px] leading-6 text-neutral-600 sm:text-right">
                        FroCort is not designed to read thoughts. We are
                        building toward measurable, interpretable changes in
                        how the mind is working.
                    </p>

                </div>

            </div>
        </section>
    );
};

export default How;